// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"f0e8b18c","693":"31d1e054","845":"e13a254d"}[chunkId] + ".chunk.js";
};